import { Box, Group, Stack, Text } from '@mantine/core';
import { isValidElement } from 'react';

import EmptyArea from '../../molecules/EmptyArea';
import { PageShellProps } from './types';
import * as classes from './styles.css';

function isStringTitle(title: PageShellProps['title']): title is string {
  return typeof title === 'string';
}

export default function PageShell({
  heightFitPage = true,
  children,
  title,
  description,
  badge,
  actions,
  tabs,
  filters,
  empty,
  contentGap,
  ...stackProps
}: PageShellProps) {
  const hasHeader =
    Boolean(title) || Boolean(actions) || Boolean(tabs) || Boolean(filters);

  return (
    <Stack
      className={heightFitPage ? classes.fitRoot : classes.overflowableRoot}
      px="xl"
      pt="xl"
      pb="lg"
      w="100%"
      gap="md"
      {...stackProps}
    >
      {hasHeader && (
        <Stack gap="md" className={classes.headerRow}>
          <Group
            justify="space-between"
            align="flex-start"
            wrap="nowrap"
            w="100%"
          >
            <Stack gap={0} style={{ flex: 1, minWidth: 0 }}>
              <Group gap="sm" align="center" wrap="nowrap">
                {isStringTitle(title) ? (
                  <Text component="h1" className={classes.title}>
                    {title}
                  </Text>
                ) : isValidElement(title) ? (
                  title
                ) : null}
                {badge}
              </Group>
              {isStringTitle(title) && description && (
                <Text className={classes.description}>{description}</Text>
              )}
            </Stack>
            {actions && (
              <Group
                gap="xs"
                align="center"
                wrap="nowrap"
                className={classes.actionsGroup}
              >
                {actions}
              </Group>
            )}
          </Group>
          {tabs && <Box>{tabs}</Box>}
          {filters && <Box>{filters}</Box>}
        </Stack>
      )}

      <Stack flex={1} mih={0} w="100%" gap={contentGap}>
        {empty ? (
          <Stack w="100%" h="100%" align="center" gap={0}>
            <Box flex={30} />
            <EmptyArea {...empty} />
            <Box flex={70} />
          </Stack>
        ) : (
          children
        )}
      </Stack>
    </Stack>
  );
}
